import React, { useState } from "react";
import moment from "moment";

import { drupalDate } from "../constants/Validators";
import Config from "../constants/Config";

const parentClassname = "react-form";

const Field = props => {
    const componentClassname = parentClassname
        ? `${parentClassname}__field`
        : "field";

    const labelPlaceholderClassname = props.labelplaceholder
        ? `${componentClassname}__label--labelplaceholder`
        : "";

    const hasErrors =
        !props.hideErrors &&
        props.errors &&
        props.errors.length &&
        props.showErrors;

    const [isFocussed, setIsFocussed] = useState(false);

    const handleFocus = () => {
        setIsFocussed(true);
    };

    const handleBlur = () => {
        setIsFocussed(false);
    };

    const formatDateForDisplay = date => {
        if (!date) return date;
        if (!isFocussed && drupalDate.validate(date)) {
            const humanDate = moment(date, Config.frontendDateFormat);
            if (humanDate.isValid()) {
                const formatted = humanDate.format(Config.frontendDateFormat);
                return formatted;
            }
        }
        return date;
    };

    return (
        <div
            className={`${componentClassname} 
				${componentClassname}--${props.type}
				${props.classes.inheritedClasses} 
				${props.classes.isDisabled} 
				${props.classes.isIncomplete} 
				${props.classes.isFocused} 
				${props.classes.hasValue}
				${props.classes.isValid}
				${props.classes.isInvalid}
			`}
        >
            <label htmlFor={props.accessibilityIds.input}>
                {/*label*/}
                {props.label ? (
                    <div
                        className={`${componentClassname}__label  ${labelPlaceholderClassname}`}
                    >
                        <div
                            className={`${componentClassname}__label__inner`}
                            id={props.accessibilityIds.label}
                        >
                            {props.label}
                            {props.required ? null : (
                                <span
                                    className={`${componentClassname}__label__optional-label`}
                                >
                                    {" "}
                                    (optional)
                                </span>
                            )}
                        </div>
                    </div>
                ) : null}
                {/* Hidden input - used to submit with */}
                <input
                    type="text"
                    value={
                        props.value
                            ? moment(
                                  props.value,
                                  Config.frontendDateFormat
                              ).format(Config.backendDateFormat)
                            : ""
                    }
                    onChange={() => {}}
                    name={props.name}
                    style={{ display: "none" }}
                />
                <div className={`${componentClassname}__input-container`}>
                    {/* input element */}
                    {React.cloneElement(props.inputElement, {
                        "aria-describedby": null,
                        value: formatDateForDisplay(props.value),
                        name: `${props.name}--formatted`,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                    })}
                    {/* Date Picker Button */}
                    <button
                        type="button"
                        className={`${componentClassname}__picker-button`}
                        data-lightbox-open={`datepicker-${props.name}`}
                        aria-label="Open datepicker"
                    >
                        <i className={`icon icon-calendar`}></i>
                    </button>
                </div>
            </label>

            {/*errors*/}
            {hasErrors ? (
                <div className={`${componentClassname}__errors`}>
                    <div
                        className={`${componentClassname}__errors__item`}
                        id={props.accessibilityIds.error}
                    >
                        {props.errors[0]}
                    </div>
                </div>
            ) : null}

            {/*info*/}
            {props.info ? (
                <div
                    className={`${componentClassname}__info`}
                    id={props.accessibilityIds.description}
                >
                    {props.info}
                </div>
            ) : null}
        </div>
    );
};

export default Field;
